import React, {useEffect, useRef} from 'react'
import { connect } from 'react-redux'

// Бейдж корзины на вкладке нижней панели мобильной оболочки (mobile-app-shell, R3).
// Показывает число позиций, а не сумму количеств: количество бывает дробным (метры, листы).

export const countPositions = incart => incart.filter(item => item.quantity > 0).length

export const positionsLabel = positions => {
    const mod10 = positions % 10
    const mod100 = positions % 100
    let word = 'позиций'
    if (mod10 === 1 && mod100 !== 11) {
        word = 'позиция'
    } else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
        word = 'позиции'
    }
    return 'Корзина, ' + positions + ' ' + word
}

export const TabbarCartBadge = ({positions}) => {

    const marker = useRef(null)

    // подпись для скринридера ставится на саму вкладку: «Корзина, 3 позиции»
    useEffect(() => {
        const tab = marker.current && marker.current.closest ? marker.current.closest('.m-tab') : null
        if (!tab) {
            return
        }
        if (positions > 0) {
            tab.setAttribute('aria-label', positionsLabel(positions))
        } else {
            tab.removeAttribute('aria-label')
        }
    }, [positions])

    const text = positions > 99 ? '99+' : String(positions)

    // key перезапускает CSS-анимацию при каждом изменении значения
    return (
        <span ref={marker}>
            {positions > 0 &&
                <span className="m-badge m-badge--pop" key={positions} aria-hidden="true">{text}</span>
            }
        </span>
    )
}

const mapStateToProps = state => ({
    positions: countPositions(state.dropdowncart.incart)
})

export default connect(
    mapStateToProps
)(TabbarCartBadge)
